 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXTCOVER from '@/components/Text/cover'
 import TEXTTITLEPAGE from '@/components/Text/titlepage'
 import TEXTCOPYRIGHT from '@/components/Text/copyright'
 import TEXTDEDICATION from '@/components/Text/dedication'
 import TEXTCONTENTS from '@/components/Text/contents'
 import TEXTPREFACE from '@/components/Text/preface'
 import TEXTINTRODUCTION from '@/components/Text/introduction'
 import TEXTBOOKONE from '@/components/Text/BookOne'
 import TEXTPART1 from '@/components/Text/part1'
 import TEXTCH1 from '@/components/Text/ch1'
 import TEXTCH2 from '@/components/Text/ch2'
 import TEXTPART2 from '@/components/Text/part2'
 import TEXTCH3 from '@/components/Text/ch3'
 import TEXTCH4 from '@/components/Text/ch4'
 import TEXTPART3 from '@/components/Text/part3'
 import TEXTCH5 from '@/components/Text/ch5'
 import TEXTCH6 from '@/components/Text/ch6'
 import TEXTPART4 from '@/components/Text/part4'
 import TEXTCH7 from '@/components/Text/ch7'
 import TEXTCH8 from '@/components/Text/ch8'
 import TEXTCH9 from '@/components/Text/ch9'
 import TEXTPART5 from '@/components/Text/part5'
 import TEXTCH10 from '@/components/Text/ch10'
 import TEXTCH11 from '@/components/Text/ch11'
 import TEXTBOOKTWO from '@/components/Text/BookTwo'
 import TEXTPART6 from '@/components/Text/part6'
 import TEXTCH12 from '@/components/Text/ch12'
 import TEXTCH13 from '@/components/Text/ch13'
 import TEXTPART7 from '@/components/Text/part7'
 import TEXTCH14 from '@/components/Text/ch14'
 import TEXTCH15 from '@/components/Text/ch15'
 import TEXTCH16 from '@/components/Text/ch16'
 import TEXTCH17 from '@/components/Text/ch17'
 import TEXTCH18 from '@/components/Text/ch18'
 import TEXTCH19 from '@/components/Text/ch19'
 import TEXTCH20 from '@/components/Text/ch20'
 import TEXTPART8 from '@/components/Text/part8'
 import TEXTCH21 from '@/components/Text/ch21'
 import TEXTCH22 from '@/components/Text/ch22'
 import TEXTCH23 from '@/components/Text/ch23'
 import TEXTCH24 from '@/components/Text/ch24'
 import TEXTCH25 from '@/components/Text/ch25'
 import TEXTPART9 from '@/components/Text/part9'
 import TEXTCH26 from '@/components/Text/ch26'
 import TEXTCH27 from '@/components/Text/ch27'
 import TEXTCH28 from '@/components/Text/ch28'
 import TEXTPART10 from '@/components/Text/part10'
 import TEXTCH29 from '@/components/Text/ch29'
 import TEXTCH30 from '@/components/Text/ch30'
 import TEXTCH31 from '@/components/Text/ch31'
 import TEXTCH32 from '@/components/Text/ch32'
 import TEXTPART11 from '@/components/Text/part11'
 import TEXTCH33 from '@/components/Text/ch33'
 import TEXTCH34 from '@/components/Text/ch34'
 import TEXTAFTERWORD from '@/components/Text/afterword'
 import TEXTNOTES from '@/components/Text/notes'
 import TEXTNAMEINDEX from '@/components/Text/nameindex'
 import TEXTSUBJECTINDEX from '@/components/Text/subjectindex'
 import TEXTSCRIPTUREINDEX from '@/components/Text/scriptureindex'
 import TEXTPRAISEFOR from '@/components/Text/praisefor'
 import TEXTABOUTAUTHORS from '@/components/Text/aboutauthors'
 import TEXTMOREIVP from '@/components/Text/moreIVP'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Text/cover",
 			"name" : "Text/cover",
 			"component" : TEXTCOVER
 		},
 		{
 			"path" : "/Text/titlepage",
 			"name" : "Text/titlepage",
 			"component" : TEXTTITLEPAGE
 		},
 		{
 			"path" : "/Text/copyright",
 			"name" : "Text/copyright",
 			"component" : TEXTCOPYRIGHT
 		},
 		{
 			"path" : "/Text/dedication",
 			"name" : "Text/dedication",
 			"component" : TEXTDEDICATION
 		},
 		{
 			"path" : "/Text/contents",
 			"name" : "Text/contents",
 			"component" : TEXTCONTENTS
 		},
 		{
 			"path" : "/Text/preface",
 			"name" : "Text/preface",
 			"component" : TEXTPREFACE
 		},
 		{
 			"path" : "/Text/introduction",
 			"name" : "Text/introduction",
 			"component" : TEXTINTRODUCTION
 		},
 		{
 			"path" : "/Text/BookOne",
 			"name" : "Text/BookOne",
 			"component" : TEXTBOOKONE
 		},
 		{
 			"path" : "/Text/part1",
 			"name" : "Text/part1",
 			"component" : TEXTPART1
 		},
 		{
 			"path" : "/Text/ch1",
 			"name" : "Text/ch1",
 			"component" : TEXTCH1
 		},
 		{
 			"path" : "/Text/ch2",
 			"name" : "Text/ch2",
 			"component" : TEXTCH2
 		},
 		{
 			"path" : "/Text/part2",
 			"name" : "Text/part2",
 			"component" : TEXTPART2
 		},
 		{
 			"path" : "/Text/ch3",
 			"name" : "Text/ch3",
 			"component" : TEXTCH3
 		},
 		{
 			"path" : "/Text/ch4",
 			"name" : "Text/ch4",
 			"component" : TEXTCH4
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js